import { baseUrl } from "../connections";

const fetchWithAuth = async (url, token) => {
  const headers = { "Content-Type": "application/json" };
  if (token) headers["x-auth-token"] = token;
  const res = await fetch(url, { headers, cache: "no-store" });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
};

export const fetchCategories = ({ city_uuid, user_uuid, token }) =>
  fetchWithAuth(
    `${baseUrl}/category/list?search=&user_uuid=${user_uuid ?? ""}&city_uuid=${city_uuid ?? ""}`,
    token,
  );

export const fetchBrands = ({
  category_uuid,
  country_uuid,
  state_uuid,
  city_uuid,
  county_uuid,
  user_uuid,
  user_lng,
  user_lat,
  token,
}) => {
  const geoParams =
    user_lng != null ? `&user_lng=${user_lng}&user_lat=${user_lat}` : "";
  return fetchWithAuth(
    `${baseUrl}/user/brand/list?pagenum=0&limit=16&user_uuid=${user_uuid ?? ""}&category_uuid=${category_uuid ?? ""}&country_uuid=${country_uuid ?? ""}&state_uuid=${state_uuid ?? ""}&city_uuid=${city_uuid ?? ""}&county_uuid=${county_uuid ?? ""}&brand_uuid=${geoParams}`,
    token,
  );
};

export const fetchSubCategories = ({
  category_uuid,
  country_uuid,
  state_uuid,
  city_uuid,
  county_uuid,
  user_uuid,
  brand_uuid,
  token,
}) =>
  fetchWithAuth(
    `${baseUrl}/sub_category/lists?user_uuid=${user_uuid ?? ""}&category_uuid=${category_uuid ?? ""}&country_uuid=${country_uuid ?? ""}&state_uuid=${state_uuid ?? ""}&city_uuid=${city_uuid ?? ""}&county_uuid=${county_uuid ?? ""}${brand_uuid?.length > 0 ? `&brand_uuid=${brand_uuid}` : ""}&search=`,
    token,
  );

export const fetchMails = ({ params, token }) =>
  fetchWithAuth(`${baseUrl}/mail/list?${params}`, token);

export const fetchDoYouKnow = ({ storeUuid, token }) => {
  if (!storeUuid) return null;
  return fetchWithAuth(`${baseUrl}/store/profile/${storeUuid}`, token);
};

export const fetchQuickOffers = ({ storeUuid, token }) => {
  if (!storeUuid) return null;
  return fetchWithAuth(
    `${baseUrl}/store/quick-offers?store_uuid=${storeUuid}&active_only=true&exclude_expired=true`,
    token,
  );
};

// Live catalog promotions (coupon & product mgmt), grouped by category.
export const fetchStorePromotions = ({ storeUuid, token }) => {
  if (!storeUuid) return null;
  return fetchWithAuth(
    `${baseUrl}/store/coupon/consumer/${storeUuid}/promotions`,
    token,
  );
};

// In-store redemption request: the store owner has up to 1 minute to confirm
// on-site before it expires (see PromotionRedemption on the backend). Throws
// with `error.body` set to the parsed error response so callers can check
// `already_redeemed` / `max_attempts_reached` without a second round trip.
export const redeemPromotion = async ({ storeUuid, promotionUuid, token }) => {
  const headers = { "Content-Type": "application/json" };
  if (token) headers["x-auth-token"] = token;
  const res = await fetch(
    `${baseUrl}/store/coupon/consumer/${storeUuid}/promotions/${promotionUuid}/redeem`,
    { method: "POST", headers, cache: "no-store" },
  );
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const error = new Error(body?.message || "Redeem request failed");
    error.body = body;
    throw error;
  }
  return body;
};
